var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7852 10.2858L13.8327 13.3333M7.52963 2.66667C6.66659 2.66667 5.82293 2.92259 5.10534 3.40207C4.38774 3.88155 3.82845 4.56306 3.49818 5.3604C3.16791 6.15775 3.08149 7.03512 3.24986 7.88158C3.41823 8.72804 3.83383 9.50556 4.44409 10.1158C5.05435 10.7261 5.83187 11.1417 6.67833 11.31C7.52479 11.4784 8.40216 11.392 9.19951 11.0617C9.99686 10.7315 10.6784 10.1722 11.1578 9.45458C11.6373 8.73698 11.8932 7.89332 11.8932 7.03028C11.8932 5.873 11.4334 4.76315 10.6151 3.94483C9.79677 3.12651 8.68691 2.66675 7.52963 2.66667Z",
    stroke: "#F6F8FA",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.b8e91a20eff70a0255a9001d8b4839cd.svg";
export { ForwardRef as ReactComponent };